import { render, staticRenderFns } from "./branding-header.vue?vue&type=template&id=567c01c6&scoped=true&"
var script = {}
import style0 from "./branding-header.vue?vue&type=style&index=0&id=567c01c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567c01c6",
  null
  
)

export default component.exports